import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { SnackbarProvider } from 'contexts/SnackbarContext'
import { AccountsProvider } from 'contexts/AccountContext'
import theme from 'theme'
import AppRoutes from 'routers/AppRoutes'

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <BrowserRouter>
          <AccountsProvider>
            <AppRoutes />
          </AccountsProvider>
        </BrowserRouter>
      </SnackbarProvider>
    </ThemeProvider>
  )
}

export default App
